// @flow

import * as React from 'react';
import MenuItem from './MenuItem';
import MenuPage from './MenuPage';
import { trackAnchor } from '../GoogleAnalyticsWrapper';

type Props = {
  children: React.Node,
  className?: string,
  scrollableElement?: ?HTMLDivElement,
  scrollSelf?: boolean,
}

type State = {
  nextValue: string,
  childrens: React.Node,
}

class ParalaxScroller extends React.Component<Props, State> {
  static defaultProps = {
    className: '',
    scrollableElement: null,
    scrollSelf: false,
  };

  state: State = {
    nextValue: '',
    childrens: this.updateAsideNav(React.Children.toArray(this.props.children)),
  };

  currentValue: string;

  refTab: { [key: string]: HTMLDivElement } = {};
  ref: ?HTMLDivElement;

  enterWaypoint = (value: string) => {
    // if (this.state.nextValue && this.state.nextValue !== value) {
    //   return;
    // }
    trackAnchor(value);
    this.currentValue = value;
    this.setState({
      nextValue: '',
      childrens: this.updateAsideNav(React.Children.toArray(this.props.children)),
    });
  };

  shouldComponentUpdate(nextProps: Props, nextState: State): boolean {
    if (nextProps.children !== this.props.children) {
      nextState.nextValue = '';
      nextState.childrens = this.updateAsideNav(React.Children.toArray(nextProps.children));
    }
    return true;
  }

  // $FlowFixMe
  overloadReactElement(reactElement: React.Node): React.Node {
    if (reactElement.type === MenuItem) {
      return React.cloneElement(reactElement, {
        ...reactElement.props,
        key: `${reactElement.props.id}Item`,
        selected: this.currentValue,
        onClick: () => this.scrollToMyRef(reactElement.props.id),
      });
    } else if (reactElement.type === MenuPage) {
      return React.cloneElement(reactElement, {
        ...reactElement.props,
        key: `${reactElement.props.id}Page`,
        enterWaypoint: id => this.enterWaypoint(id),
        refSave: ref => this.saveRef(reactElement.props.id, ref),
      });
    } else if (reactElement.type === 'div') {
      return React.cloneElement(reactElement, {
        ...reactElement.props,
        children: reactElement.props ?
          // $FlowFixMe
          this.updateAsideNav(reactElement.props.children) :
          null,
      });
    }
    return reactElement;
  }

  updateAsideNav(elementArray: React.Node): React.Node {
    if (!elementArray) {
      return null;
    }
    if (!Array.isArray(elementArray)) {
      return this.overloadReactElement(elementArray);
    }
    return elementArray.map(reactElement => this.overloadReactElement(reactElement));
  }

  saveRef = (refId: string, ref: HTMLDivElement) => {
    this.refTab[refId] = ref;
  };

  scrollToMyRef = (refId: string) => {
    this.setState({ nextValue: refId });
    let scrollableElt: HTMLDivElement = window;
    if (this.props.scrollableElement) {
      scrollableElt = this.props.scrollableElement;
    }
    if (this.ref && this.props.scrollSelf) {
      scrollableElt = this.ref;
    }
    // $FlowFixMe
    scrollableElt.scrollTo({
      top: this.refTab[refId].offsetTop,
      behavior: 'smooth',
    });
  };

  render() {
    return (
      <div
        ref={(ref) => {
          this.ref = ref;
        }}
        className={this.props.className}
      >
        {this.state.childrens}
      </div>
    );
  }
}

export default ParalaxScroller;
